import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurWashingtonDC = () => (
  <SEOPageTemplate
    city="Washington"
    state="DC"
    route="/chauffeur-washington-dc"
    imageSrc="/washington-dc-limo.jpg"
    introduction="In the nation's capital, where diplomacy meets business, TiLimousine delivers a transportation service that understands the unique demands of Washington DC. Our chauffeurs are well-versed in navigating the city's security protocols, diplomatic zones, and high-profile events. From Capitol Hill to K Street, from Georgetown to the Wharf, we ensure your journey through DC is conducted with the utmost professionalism and discretion that this distinguished city requires."
    testimonial={{
      quote: "As a government relations consultant, I need transportation that understands DC's unique security requirements and diplomatic protocols. TiLimousine's chauffeurs are familiar with all the government buildings and embassies, making my meetings across the city seamless and secure.",
      author: "James W.",
      role: "Senior Policy Advisor, DC Government Relations"
    }}
    fboLink={{
      url: "https://signatureflight.com/locations/washington-dulles",
      name: "Signature Aviation – Washington Dulles"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: DC ⇄ NYC, DC ⇄ Philadelphia',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Washington DC',
      'Best chauffeur in DC',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Washington DC',
      'Best executive car service in DC',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Ronald Reagan Washington National Airport (DCA)',
      'Dulles International Airport (IAD)',
      'Baltimore/Washington International (BWI)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA'
    ]}
    neighborhoods={[
      'Capitol Hill',
      'K Street',
      'Georgetown',
      'The Wharf',
      'Downtown DC',
      'Foggy Bottom',
      'Penn Quarter',
      'Navy Yard',
      'Adams Morgan',
      'Dupont Circle',
      'Arlington',
      'Greater Washington DC Area'
    ]}
  />
);

export default ChauffeurWashingtonDC; 